// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Added the comments
// MODIFIED DATE : 17-09-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/***************** FETCH FUTURE DEMAND REPORT START *************** */
export const getFutureDemandReportDetails = (fetchData: any) => {
	const data = {
		FutureDemandDetailsToken: fetchData,
	};
	const url = `${API_URL}futureDemandReportToken`;
	return makeApiCall(url, data);
};
/***************** FETCH FUTURE DEMAND REPORT END *************** */
